import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { latestReceivedDay } from '@/features/documents/received-date'

export interface ReceivedOnFieldProps {
  /** The day (`YYYY-MM-DD`) the batch was received on; '' for the upload time. */
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

/**
 * The upload dialog's optional "Received on" day for the whole batch (ADR-0094): when the case
 * received the files, which dates every event of them. Left empty, it is the upload time.
 */
export function ReceivedOnField({ value, onChange, disabled }: ReceivedOnFieldProps) {
  const { t } = useTranslation()
  const id = useId()
  return (
    <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
      <Label htmlFor={id} className="text-xs text-muted-foreground">
        {t('cases.documents.upload.receivedOn')}
      </Label>
      <Input
        id={id}
        type="date"
        value={value}
        max={latestReceivedDay()}
        disabled={disabled}
        onChange={event => onChange(event.target.value)}
        className="h-8 w-auto px-2"
      />
      <p className="text-xs text-muted-foreground/70 basis-full md:basis-auto">
        {t('cases.documents.upload.receivedOnHint')}
      </p>
    </div>
  )
}
